/** "1 day", "14 days": every day count a person or DANI reads goes through this (UAT F63). */
export function daysWord(n: number): string {
    return `${n} ${n === 1 ? 'day' : 'days'}`;
}
